import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Inline calendar on the PV report: days with readings get a dot, picking a
// day shows its report.
export default class extends Controller {
  static values = { availableDates: Array, date: String, url: String }

  connect() {
    const available = new Set(this.availableDatesValue)

    this.picker = flatpickr(this.element, {
      inline: true,
      locale: "pl",
      defaultDate: this.dateValue,
      onDayCreate: (_selected, _str, _fp, day) => {
        if (day.dateObj && available.has(isoDate(day.dateObj))) {
          day.classList.add("pv-has-data")
        }
      },
      onChange: (selectedDates) => {
        if (selectedDates.length) {
          window.Turbo.visit(`${this.urlValue}?date=${isoDate(selectedDates[0])}`)
        }
      }
    })
  }

  disconnect() {
    this.picker?.destroy()
  }
}

function isoDate(date) {
  return date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, "0") + "-" +
    String(date.getDate()).padStart(2, "0")
}
